import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function PropertyTypeInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is your property type?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Different types of rental property are reported differently on your
          tax return. Selecting the correct category ensures your expenses,
          depreciation, and income are handled accurately.
        </p>
        <p>
          <strong>Options:</strong>
        </p>
        <ul>
          <li>
            <strong>Single Family:</strong> A standalone residential home you
            rent to one household.
          </li>
          <li>
            <strong>Multi Family:</strong> A residential property with two or
            more units (duplex, triplex, apartment building) that you rent.
          </li>
          <li>
            <strong>Vacation Rental:</strong> A property you rent short-term for
            leisure or travel stays. You may also use it personally for part of
            the year.
          </li>
          <li>
            <strong>Commercial:</strong> A property you rent to businesses
            rather than individuals. Examples include office space, retail
            space, or warehouses.
          </li>
          <li>
            <strong>Land:</strong> Unimproved or vacant land that you rent out
            (no buildings or structures).
          </li>
          <li>
            <strong>Royalties:</strong> Income you get from natural resources
            located on the property, like oil, gas, or minerals.
          </li>
          <li>
            <strong>Self Rental:</strong> A property you rent to your own
            business or a business you control.
          </li>
          <li>
            <strong>Other:</strong> Use this if your property does not fit any
            of the categories above.
          </li>
        </ul>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Publication 527 (2024), Residential Rental Property',
              url: 'https://www.irs.gov/publications/p527',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
